import { queryOptions } from '@tanstack/react-query';
import { SupplyPointService } from './services/SupplyPointService';

export const supplyPointQueryKeys = {
  all: ['supply-points'] as const,
  lists: () => [...supplyPointQueryKeys.all, 'list'] as const,
  list: () => [...supplyPointQueryKeys.lists()] as const,
  details: () => [...supplyPointQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...supplyPointQueryKeys.details(), id] as const,
  types: () => [...supplyPointQueryKeys.all, 'types'] as const,
  access: () => [...supplyPointQueryKeys.all, 'access'] as const,
  accessList: () => [...supplyPointQueryKeys.access(), 'list'] as const,
  accessDetail: (id: number) => [...supplyPointQueryKeys.access(), 'detail', id] as const,
};

export const supplyPointQueries = {
  list: () =>
    queryOptions({
      queryKey: supplyPointQueryKeys.list(),
      queryFn: SupplyPointService.getList,
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: supplyPointQueryKeys.detail(id),
      queryFn: () => SupplyPointService.getById(id),
    }),

  types: () =>
    queryOptions({
      queryKey: supplyPointQueryKeys.types(),
      queryFn: SupplyPointService.getTypes,
    }),

  accessList: () =>
    queryOptions({
      queryKey: supplyPointQueryKeys.accessList(),
      queryFn: SupplyPointService.getAccessList,
    }),

  accessDetail: (id: number) =>
    queryOptions({
      queryKey: supplyPointQueryKeys.accessDetail(id),
      queryFn: () => SupplyPointService.getAccessById(id),
    }),

  accessBySupplyPoint: (supplyPointId: number) =>
    queryOptions({
      ...supplyPointQueries.accessList(),
      select: (data) => data.filter((a) => a.system === supplyPointId),
    }),

  byOrganization: (orgId: number) =>
    queryOptions({
      ...supplyPointQueries.list(),
      select: (data) => data.filter((sp) => sp.partners.some((p) => p.id === orgId)),
    }),
};
